import React, { Suspense, lazy, useEffect, useRef } from 'react';

/**
 * Die beiden Overlays (Guide-Formular und Calendly-Kalender) werden erst
 * heruntergeladen, wenn sie das erste Mal geöffnet werden. Beim ersten
 * Seitenaufruf muss dadurch spürbar weniger Code geladen werden – sichtbar
 * ändert sich nichts.
 */
const GuideModal = lazy(() => import('./GuideModal').then(m => ({
  default: m.GuideModal
})));
const CalendlyModal = lazy(() => import('./CalendlyModal').then(m => ({
  default: m.CalendlyModal
})));
function useHasBeenActive(active: boolean): boolean {
  const seen = useRef(false);
  if (active) seen.current = true;
  return seen.current;
}
type GuideProps = {
  open: boolean;
  onClose: () => void;
};
export function LazyGuideModal({
  open,
  onClose
}: GuideProps) {
  if (!useHasBeenActive(open)) return null;
  return <Suspense fallback={null} data-id="element-330" data-mp="2m7t15wci0m5t">
      <GuideModal open={open} onClose={onClose} data-id="element-331" data-mp="2m71dd7p57sq3" />
    </Suspense>;
}
type CalendlyProps = {
  open: boolean;
  onClose: () => void;
  preload?: boolean;
};
export function LazyCalendlyModal({
  open,
  onClose,
  preload = false
}: CalendlyProps) {
  const shouldRender = useHasBeenActive(open || preload);

  // Beim Überfahren des Buttons wird das Modul im Hintergrund geholt, damit der
  // Kalender beim Klick sofort bereitsteht.
  useEffect(() => {
    if (preload) void import('./CalendlyModal');
  }, [preload]);
  if (!shouldRender) return null;
  return <Suspense fallback={null} data-id="element-332" data-mp="2kr08096d4n4j">
      <CalendlyModal open={open} onClose={onClose} preload={preload} data-id="element-333" data-mp="2kqqqzb3apqaz" />
    </Suspense>;
}